import Decimal from "decimal.js";

export const deci = (value) => {
  try {
    return new Decimal(value);
  } catch (error) {
    return null;
  }
};
/**
 * Accepts big numbers
 */
export const deciB = (value) => {
  try {
    return new Decimal(value.toString());
  } catch (error) {
    return null;
  }
};

/**
 * return a formatter number with commas , can accept string , number , float , e.t.c
 */
export const formatNumber = (value, precesion = 3) => {
  const number = new Decimal(value);
  // Round the number to the max decimal places
  const roundedNumber = number.toDecimalPlaces(precesion);
  const formattedNumber = roundedNumber.toNumber().toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: precesion,
  });
  return formattedNumber;
};

export const presaleStates = {
  IN_FUTURE: 0,
  RUNNING: 1,
  PAUSED: 2,
  SOLD_OUT: 3,
  EXPIRED: 4,
};
